// extracted by mini-css-extract-plugin
export default {"ratingSummary":"RatingSummary_ratingSummary__8Q59X","stars":"RatingSummary_stars__O8SJ5","text":"RatingSummary_text__qTyE5"};